import { createGetRequest, createPostRequest } from '_helpers';

export async function getReportingExtraGrid( ) {
    return createGetRequest("reporting_getExtraGrid")
        .then(res => res.data)
        .then(({ success, data, errorMsg, redirect = false }) => {
            return { response: success, data, errorMsg, redirect };
        })
}

export async function getReporting( interval ) {
    return createPostRequest("reporting_getData", interval)
        .then(res => res.data)
        .then(({ success, data, errorMsg, redirect = false }) => {
            return { response: success, data, errorMsg, redirect };
        })
}